import { render, staticRenderFns } from "./submitted-form-preview.vue?vue&type=template&id=3d7472d8&scoped=true&"
import script from "./submitted-form-preview.vue?vue&type=script&lang=js&"
export * from "./submitted-form-preview.vue?vue&type=script&lang=js&"
import style0 from "./submitted-form-preview.vue?vue&type=style&index=0&id=3d7472d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7472d8",
  null
  
)

component.options.__file = "submitted-form-preview.vue"
export default component.exports